import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { shipDetails } from "./thunk";

const ownerSlice = createSlice({
  name: "owner",
  initialState,
  reducers: {
    setShipDetails(state, action) {
      state.shipdetails = action.payload;
    },
    setSelectedShipId(state, action) {
      state.selectedShipId = action.payload;
    },
    setSelectedOwner(state, action) {
      state.selectedOwner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(shipDetails.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(shipDetails.rejected, (state, action) => {
      state.status = "error";
    });
    builder.addCase(shipDetails.fulfilled, (state, action) => {
       state.shipdetails = action.payload;
       state.status = "success";
    });
  },
});
export const { setShipDetails, setSelectedShipId,setSelectedOwner } = ownerSlice.actions;

export default ownerSlice.reducer;
